module.exports = "<div uib-tooltip-classes=\"\" ng-class=\"{ in: isOpen() }\" class=\"cui-tooltip\"><div class=\"cui-tooltip__arrow\"></div><div ng-bind-html=\"contentExp()\" class=\"cui-tooltip__inner\"></div></div>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/adapters/ui.bootstrap.tooltip/tooltip-html-popup.jade
// module id = 840
// module chunks = 0